import {createWebHistory, createRouter} from 'vue-router'

import ThanqOrganic from '../views/ThanqOrganic'

const router = createRouter({
	history: createWebHistory(),
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return { el: to.hash }
        } else {
            return {top: 0}
        }
    },
    routes: [
        {
            path: '/sl/smartrxplus/:step?',
            name: 'home',
            component:  () => import('../views/Lander')
        }, {
            path: '/sl/oauth/:provider',
            name: 'social-auth',
            component: () => import('../views/SocialAuth')
        }, {
            path: '/sl/thanq/smartrxplus',
            name: 'thanq',
            component: () => import('../views/Thanq')
        }, {
            path: '/sl/orgthanq/smartrxplus',
            name: 'orgthanq',
            component: ThanqOrganic
        }, {
            path: '/sl/nothanq/smartrxplus',
            name: 'nothanq',
            component: () => import('../views/Thanq')
        }, {
            path: '/sl/splus',
            component: () => import('../views/upsell/SmartyPlus')
        }, {
            path: '/sl/paymenterror',
            component: () => import('../views/PaymentError')
        }
    ]
});

export default router
